import React, { useEffect, useState } from "react";
import "./App.css";
import { global } from "./API";
function App() {
  let ville = localStorage.getItem("city")
    ? localStorage.getItem("city")
    : "Arzew";
  const [data, setData] = useState({
    temperature: "loading...",
    description: "loading...",
    wind: "loading...",
    icon: "loading...",
    humidity: "loading...",
  });

  const [input, setInput] = useState("");
  const [city, setCity] = useState(ville);
  useEffect(() => {
    async function data() {
      const data = await global(city);
      
      if (data) {
        setData({
          temperature: (data.main.temp - 273.15).toFixed(0),
          description: data.weather[0].description,
          wind: data.wind.speed,
          icon: data.weather[0].icon,
          humidity: data.main.humidity,
          name: data.name,
          country: data.sys.country
        });
      } else {
        alert("Entrez le nom de la ville correctement SVP");
      }
    }
    data();
    setInput("");
  }, [city]);

  function setVille() {
    localStorage.setItem("city", input);
    setCity(input);
  }

  function enter(e) {
    if(e.key === 'Enter') {
      setVille()
    }
  }

  return (
    <div className='page'>
    <div className="App">
      <div className="input">
        <input
          placeholder="Ville..."
          onChange={(e) => setInput(e.target.value)}
          value={input}
          onKeyDown={(e) => enter(e)}
        />
        <i className="fas fa-search" onClick={setVille} />
      </div>
      <h1>{data.name === "Saint-Leu" ? "Arzew" : data.name}, {data.country}</h1>
      <div className="temp">
        <img
          src={`http://openweathermap.org/img/wn/${data.icon}@2x.png`}
          alt={data.description}
        />
        <h1>{data.temperature}°</h1>
      </div>
      <h2>
        {data.description.slice(0, 1).toUpperCase() + data.description.slice(1)}
      </h2>
      <div className="options">
        <h3>
          <span>Humidité :</span> {data.humidity} %
        </h3>
        <h3>
          <span>Vitesse du vent :</span> {(data.wind * 3.6).toFixed(0)} Km/h
        </h3>
      </div>
    </div>
      <p>Elyes &#169; 2021</p>
    </div>
  );
}

export default App;
